import { render } from "./ExtraDiensten.vue?vue&type=template&id=ba305074"
import script from "./ExtraDiensten.vue?vue&type=script&lang=js"
export * from "./ExtraDiensten.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__